import { create } from "zustand";
const initialState = {
    currentProduct: null,
    relatedProducts: [],
    hasAlreadyOwned: false,
    isOpenPassSectionModal: false,
    freeTrialData: null,
    isFreeTrialLoading: false,
    purchaseProductsInfo: {
        totalCount: 0,
        totalPrice: 0,
        selectedRelatedProducts: []
    },
    membershipAvailable: {
        usable: [],
        unusable: []
    },
    isOpenRelatedProductPreviewModal: false,
    selectedPreviewProduct: null,
    hasReview: true,
    rating: 0,
    selectedPurchaseOption: null,
    purchaseOption: null
};
const useHandoutProductStore = create((set)=>{
    return {
        currentProduct: null,
        hasAlreadyOwned: false,
        hasReview: true,
        relatedProducts: [],
        isOpenPassSectionModal: false,
        freeTrialData: null,
        isFreeTrialLoading: false,
        purchaseProductsInfo: {
            totalCount: 0,
            totalPrice: 0,
            selectedRelatedProducts: []
        },
        membershipAvailable: {
            usable: [],
            unusable: []
        },
        isOpenRelatedProductPreviewModal: false,
        selectedPreviewProduct: null,
        rating: 0,
        selectedPurchaseOption: null,
        purchaseOption: null,
        // 구매모듈에서 사용되는 purchaseOption 업데이트
        setSelectedPurchaseOption: (option)=>{
            set((state)=>{
                var _state_currentProduct_downloadPrice;
                // downloadPrice 미제공 시 열람가 1.5배(올림) 폴백 - 표시 컴포넌트와 동일 기준
                const downloadPrice = (_state_currentProduct_downloadPrice = state.currentProduct.downloadPrice) !== null && _state_currentProduct_downloadPrice !== void 0 ? _state_currentProduct_downloadPrice : Math.ceil(Number(state.currentProduct.price) * 1.5);
                return {
                    selectedPurchaseOption: option,
                    purchaseProductsInfo: {
                        ...state.purchaseProductsInfo,
                        totalCount: 1,
                        totalPrice: option === "view" ? state.currentProduct.price : downloadPrice,
                        selectedRelatedProducts: []
                    }
                };
            });
        },
        //상품페이지가 바뀌었을땐 연관교재 초기화
        updateCurrentProduct: (product)=>{
            if (!product) return set(()=>({
                    currentProduct: initialState.currentProduct,
                    selectedPurchaseOption: initialState.selectedPurchaseOption,
                    purchaseProductsInfo: initialState.purchaseProductsInfo,
                    hasReview: initialState.hasReview
                }));
            // download 제공 상품은 기본 선택값을 download로, 아니면 기존처럼 첫 옵션 사용
            const defaultPurchaseOption = product.purchaseOptions.includes("download") ? "download" : product.purchaseOptions[0];
            var _product_downloadPrice;
            // downloadPrice 미제공 시 열람가 1.5배(올림) 폴백 - 표시 컴포넌트와 동일 기준
            const downloadPrice = (_product_downloadPrice = product.downloadPrice) !== null && _product_downloadPrice !== void 0 ? _product_downloadPrice : Math.ceil(Number(product.price) * 1.5);
            set(()=>({
                    currentProduct: product,
                    selectedPurchaseOption: defaultPurchaseOption,
                    purchaseOption: product.purchaseOptions,
                    purchaseProductsInfo: {
                        totalCount: 1,
                        totalPrice: defaultPurchaseOption === "view" ? product.price : downloadPrice,
                        selectedRelatedProducts: []
                    },
                    hasReview: initialState.hasReview
                }));
        },
        //연과교재 업데이트시 선택상품 초기화
        updateRelatedProducts: (products)=>{
            return set((state)=>{
                var _state_currentProduct;
                if (products.length === 0) return {
                    relatedProducts: []
                };
                return {
                    relatedProducts: products,
                    purchaseProductsInfo: {
                        totalCount: state.currentProduct ? 1 : 0,
                        totalPrice: ((_state_currentProduct = state.currentProduct) === null || _state_currentProduct === void 0 ? void 0 : _state_currentProduct.price) || 0,
                        selectedRelatedProducts: []
                    }
                };
            });
        },
        toggleRelatedProductSelected: (product)=>set((state)=>{
                const find = state.purchaseProductsInfo.selectedRelatedProducts.find((item)=>item.id === product.id);
                const newSelectedBookList = find ? state.purchaseProductsInfo.selectedRelatedProducts.filter((item)=>item.id !== product.id) : [
                    ...state.purchaseProductsInfo.selectedRelatedProducts,
                    product
                ];
                const isPurchaseOptionViewType = state.selectedPurchaseOption === "view";
                return {
                    purchaseProductsInfo: {
                        totalCount: newSelectedBookList.length + 1,
                        totalPrice: newSelectedBookList.reduce((acc, cur)=>acc + (isPurchaseOptionViewType ? cur.price : cur.downloadPrice), 0) + (isPurchaseOptionViewType ? state.currentProduct.price : state.currentProduct.downloadPrice),
                        selectedRelatedProducts: newSelectedBookList
                    }
                };
            }),
        updatePurchaseProductsInfo: (info)=>set(()=>{
                return {
                    purchaseProductsInfo: info
                };
            }),
        updateMembershipAvailable: (unUsableProductIds)=>{
            set((state)=>{
                const usable = state.purchaseProductsInfo.selectedRelatedProducts.filter((product)=>!unUsableProductIds.includes(product.id));
                const unusable = state.purchaseProductsInfo.selectedRelatedProducts.filter((product)=>unUsableProductIds.includes(product.id));
                return {
                    membershipAvailable: {
                        usable,
                        unusable
                    }
                };
            });
        },
        openPassSectionModal: ()=>set(()=>({
                    isOpenPassSectionModal: true
                })),
        closePassSectionModal: ()=>set(()=>({
                    isOpenPassSectionModal: false
                })),
        openRelatedProductPreviewModal: (product)=>set(()=>({
                    isOpenRelatedProductPreviewModal: true,
                    selectedPreviewProduct: product
                })),
        closeRelatedProductPreviewModal: ()=>set(()=>({
                    isOpenRelatedProductPreviewModal: false,
                    selectedPreviewProduct: null
                })),
        setHasAlreadyOwned: (hasAlreadyOwned)=>set(()=>({
                    hasAlreadyOwned
                })),
        setFreeTrialData: function(data) {
            let isLoading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return set(()=>({
                    freeTrialData: data,
                    isFreeTrialLoading: isLoading
                }));
        },
        setHasReview: (hasReview)=>set(()=>({
                    hasReview
                })),
        setRating: (rating)=>set(()=>({
                    rating
                }))
    };
});
export default useHandoutProductStore;
